import { store } from "../app/reducers";
import CONFIG from "./Config";

// Право доступа. name — полный слаг ('admin.nodes.show'),
// prefix — префикс сущности ('admin.nodes') для проверки смежных прав.
// Список прав пользователя приходит из логина и лежит в state.app.userPermissions.
//
// ЕДИНСТВЕННАЯ точка проверки прав на фронте (меню, роутер, кнопки карточек) — при
// CONFIG.permissionsEnabled=false (текущий дефолт) всегда true, все аккаунты равны.
export default class Permission {
    constructor(name, prefix = null) {
        this.name = name;
        this.prefix = prefix;
    }

    check() {
        return Permission.Check(this.name);
    }

    static Check(name) {
        if (!CONFIG.permissionsEnabled) return true;
        const userPermissions = store.getState().app.userPermissions;
        return Array.isArray(userPermissions) && userPermissions.includes(name);
    }
}
